const URLS = {
  preferredProvidersInstructions:
    'https://9056483.fs1.hubspotusercontent-na1.net/hubfs/9056483/Vim%20Order%20Assist%20Preferred%20Providers%20-%20Overview%20and%20Activation%20Instructions.pdf',
};

export default URLS;
